const BLACKLIST_TYPE_DIC = [
  { label: '手机号', value: 'PHONE' },
  { label: 'IP', value: 'IP' }
];

export const safetyBlacklistOption = {
  align: 'center',
  menuAlign: 'center',
  headerAlign: 'center',
  border: true,
  expand: false,
  stripe: false,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: 240,
  labelWidth: 120,
  defaultSort: {
    prop: 'createTime',
    order: 'descending'
  },
  column: [
    {
      label: '类型',
      prop: 'type',
      type: 'select',
      search: true,
      dicData: BLACKLIST_TYPE_DIC,
      rules: [
        {
          required: true,
          trigger: 'change',
          message: '请选择黑名单类型'
        }
      ]
    },
    {
      label: 'ID',
      prop: 'id',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '黑名单内容',
      prop: 'content',
      search: true,
      type: 'input',
      rules: [
        {
          required: true,
          trigger: 'blur',
          message: '请输入黑名单内容'
        },
        {
          pattern: /^1[3-9]\d{9}$/,
          trigger: 'blur',
          message: '请输入正确的手机号'
        }
      ]
    },
    {
      label: '备注',
      prop: 'remark',
      type: 'input',
      hide: true,
      addDisplay: true,
      editDisplay: true
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'datetime',
      sortable: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      addDisplay: false,
      editDisplay: false
    },
  ]
};